// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Contact from "./contact.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": true,
        "type": "uuid"
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": true,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "send_email": {
      "column": {
        "default": false,
        "name": "send_email",
        "null": false,
        "type": "boolean"
      },
      "name": "send_email",
      "selected_by_default": null,
      "translated": null
    },
    "send_sms": {
      "column": {
        "default": false,
        "name": "send_sms",
        "null": false,
        "type": "boolean"
      },
      "name": "send_sms",
      "selected_by_default": null,
      "translated": null
    },
    "sender_name": {
      "column": {
        "default": "SKOLEELEVER",
        "name": "sender_name",
        "null": false,
        "type": "string"
      },
      "name": "sender_name",
      "selected_by_default": null,
      "translated": null
    },
    "simple_text": {
      "column": {
        "default": null,
        "name": "simple_text",
        "null": true,
        "type": "text"
      },
      "name": "simple_text",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": null,
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "subject": {
      "column": {
        "default": null,
        "name": "subject",
        "null": false,
        "type": "string"
      },
      "name": "subject",
      "selected_by_default": null,
      "translated": null
    },
    "text": {
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      },
      "name": "text",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Message",
  "collectionKey": "messages",
  "collectionName": "messages",
  "i18nKey": "message",
  "camelizedLower": "message",
  "name": "Message",
  "nameDasherized": "message",
  "pluralName": "messages",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "attachments_attachments",
      "macro": "has_many",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "attachments_blobs",
      "macro": "has_many",
      "resource_name": "ActiveStorageBlob",
      "through": "attachments_attachments"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "message_recipients"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "creator_id",
      "name": "creator",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "MessageRecipient",
      "collectionName": "message_recipients",
      "foreignKey": "message_id",
      "name": "message_recipients",
      "macro": "has_many",
      "resource_name": "MessageRecipient",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantDomain",
      "collectionName": "tenant_domains",
      "foreignKey": "tenant_domain_id",
      "name": "tenant_domain",
      "macro": "belongs_to",
      "resource_name": "TenantDomain",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "creator_id",
      "column": {
        "default": null,
        "name": "creator_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_creator_id",
      "column": {
        "default": null,
        "name": "old_creator_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_resource_id",
      "column": {
        "default": null,
        "name": "old_resource_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "send_email",
      "column": {
        "default": false,
        "name": "send_email",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "send_sms",
      "column": {
        "default": false,
        "name": "send_sms",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "sender_name",
      "column": {
        "default": "SKOLEELEVER",
        "name": "sender_name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "simple_text",
      "column": {
        "default": null,
        "name": "simple_text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "state",
      "column": {
        "default": null,
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "subject",
      "column": {
        "default": null,
        "name": "subject",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_domain_id",
      "column": {
        "default": null,
        "name": "tenant_domain_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text",
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "message_recipients"
    }
  ],
  "paramKey": "message",
  "primaryKey": "id"
}

/** Frontend model for Message. */
export default class Message extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  sendEmail() {
    return this.readAttributeUnderscore("send_email")
  }

  /** @returns {boolean} */
  hasSendEmail() {
    const value = this.sendEmail()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  sendSms() {
    return this.readAttributeUnderscore("send_sms")
  }

  /** @returns {boolean} */
  hasSendSms() {
    const value = this.sendSms()

    return this._isPresent(value)
  }

  /** @returns {string} */
  senderName() {
    return this.readAttributeUnderscore("sender_name")
  }

  /** @returns {boolean} */
  hasSenderName() {
    const value = this.senderName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  simpleText() {
    return this.readAttributeUnderscore("simple_text")
  }

  /** @returns {boolean} */
  hasSimpleText() {
    const value = this.simpleText()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string} */
  subject() {
    return this.readAttributeUnderscore("subject")
  }

  /** @returns {boolean} */
  hasSubject() {
    const value = this.subject()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  text() {
    return this.readAttributeUnderscore("text")
  }

  /** @returns {boolean} */
  hasText() {
    const value = this.text()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static preview(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "preview",
        collectionName: "messages",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  sendMessage(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "send_message",
        primaryKey: this.primaryKey(),
        collectionName: "messages",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./contact.js").default>} */
  contacts() {
    return new Collection(
      {
        reflectionName: "contacts",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Message",
            id: this.primaryKey(),
            reflection: "contacts"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  loadContacts() {
    return this._loadHasManyReflection(
      {
        reflectionName: "contacts",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Message",
            id: this.primaryKey(),
            reflection: "contacts"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./contact.js").default>>} */
  ensureContactsLoaded() {
    return this.ensureAssociationLoaded("contacts")
  }
}
